/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/exampleMethod.js';
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
    }
});

/* Components */
app.component('SuggestionForm', defineAsyncComponent(() => import('../../components/SuggestionForm.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
